import { Grid, Stack } from '@mui/material';

import { PRE_ADJ_SECTIONS } from '../../constants/puntajeConstants';
import { formatInteger } from '../../utils/puntajeFormatters';
import MetricCard from '../common/MetricCard';
import PreAdjudicationsTable from './PreAdjudicationsTable';
import TabPanel from '../common/TabPanel';

const PreadjudicationsOverviewTab = ({
  preAdjudicationsRows,
  isLoading,
  paginations,
  activeTab,
}) => (
  <Stack>
    <Grid container sx={{ bgcolor: 'white' }}>
      <Grid item xs={12} sm={6} md={3} p={2}>
        <MetricCard
          title="Historicos"
          value={formatInteger(preAdjudicationsRows.length)}
          subtitle="Total del grupo seleccionado"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} p={2}>
        <MetricCard
          title="Por Puntaje"
          value={formatInteger(
            preAdjudicationsRows.filter((row) => row.pre_adjudication_type === 'PUNTAJE').length
          )}
          subtitle="Confirmadas por fondo puntaje"
          color="success.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} p={2}>
        <MetricCard
          title="Por Sorteo"
          value={formatInteger(
            preAdjudicationsRows.filter((row) => row.pre_adjudication_type === 'SORTEO').length
          )}
          subtitle="Confirmadas por sorteo"
          color="warning.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} p={2}>
        <MetricCard
          title="Por Desborde"
          value={formatInteger(
            preAdjudicationsRows.filter((row) => row.pre_adjudication_type === 'DESBORDE').length
          )}
          subtitle="Confirmadas por tope de fondo"
          color="info.main"
        />
      </Grid>
    </Grid>

    {PRE_ADJ_SECTIONS.map((section) => (
      <TabPanel
        key={section.key}
        activeTab={activeTab}
        index={PRE_ADJ_SECTIONS.findIndex((item) => item.key === section.key)}
      >
        <PreAdjudicationsTable
          title={section.title}
          rows={paginations?.[section.key]?.data || []}
          isLoading={isLoading}
          pagination={paginations?.[section.key]}
        />
      </TabPanel>
    ))}
  </Stack>
);

export default PreadjudicationsOverviewTab;
